export const DASHBOARD_CONTAINER = "/dashboard";
export const DASHBOARD = "/dashboard/list";
export const FEED = "/feed";
export const FEED_DETAILS = "/mv";
export const TOPICS = "/topics";
export const SOCIAL = "social";
export const WIDGET = "/dashboard/{dashboard_id}/widget";
export const REPORT = "/charts";
export const ROOT_ROUTE = "/";
export const APP_ROUTE = "/";
export const TERMS_AND_SERVICES = "/terms-and-services";
export const PRIVACY_POLICIES = "/privacy-policies";
export const TAGS = "/tags_favourites/tags";
export const FAVOURTIES = "/tags_favourites/favourites";
export const ARTICLE_TRACKING = "/article-tracking";
export const NAVBAR_EXCLUDED_ROUTES = [
  "/privacy-policies",
  "/terms-and-services",
  "/",
  "/forgot-password",
];
export const FEED_DETAILS_ALL = ["/mv/ad/", "/mv/oad", "/mv/sad"];
export const FORGOT_PASSWORD = "/forgot-password";
export const LINK_SOCIAL_PAGE = "/link-pages";
export const printAndOnlineRegex = /[0-9]+-[0-9]+-[0-9]/; // for print and online - article id's url pattern
export const socialDetailsPageRegex =
  /(bafad)|(sad)\/\/?([0-9])+-([0-9])+\/([^~'])+?/g; // for social and blogs & forums details page - article id's url pattern
